class CreateDomesticStayReq{

    constructor() {
  
       
        this.Id = undefined;

        this.PatientId = undefined;

        this.StartDate = undefined;
        this.StartDateSearchTo = undefined;

        this.EndDate = undefined;
        this.EndDateSearchTo = undefined;

        this.NumberOfDays = undefined;
        this.NumberOfDaysSearchTo = undefined;

        this.RoomId = undefined;

        this.IsActive = undefined;

        this.RoomType = undefined;

        this.Price= undefined;
        this.PriceSearchTo= undefined;

        this.InsurancePrice= undefined;
        this.InsurancePriceSearchTo = undefined;

        this.OverHeadPrice = undefined;
        this.OverHeadPriceSearchTo = undefined;
        
        this.PricePaid = undefined;
        this.PricePaidSearchTo = undefined;

        this.OverHeadPricePaid = undefined;
        this.OverHeadPricePaidSearchTo = undefined;

        this.InsurancePricePaid = undefined;

        this.InsurancePricePaidSearchTo = undefined;

        this.ExtrasPrice = undefined;

        this.ExtrasPriceSearchTo= undefined;

        this.ExtrasPricePaid = undefined;

        this.ExtrasPricePaidSearchTo= undefined;

        this.Notes= undefined;

      this.pagingParams = {
        pageNumber: undefined,
        pageSize: undefined,
      }
  
      
    }
  }
  export default CreateDomesticStayReq;